import BaseSVG, { BaseSVGProps, STROKE_WIDTH } from '../BaseSVG'

export const UserIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG {...props} strokeWidth={STROKE_WIDTH.BASE} viewBox="0 0 14 14" fill="none">
      <path
        d="M12.3334 13V11.6667C12.3334 10.9594 12.0525 10.2811 11.5524 9.78105C11.0523 9.28095 10.374 9 9.66675 9H4.33341C3.62617 9 2.94789 9.28095 2.4478 9.78105C1.9477 10.2811 1.66675 10.9594 1.66675 11.6667V13M9.66675 3.66667C9.66675 5.13943 8.47284 6.33333 7.00008 6.33333C5.52732 6.33333 4.33341 5.13943 4.33341 3.66667C4.33341 2.19391 5.52732 1 7.00008 1C8.47284 1 9.66675 2.19391 9.66675 3.66667Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSVG>
  )
}
